<script>
	import { onMount } from "svelte";
	import { fly } from "svelte/transition";
	import { createEventDispatcher } from "svelte";

	export let id = "";
	export let value = [];
	export let readonly = false;
	export let placeholder = "";
	export let options = [];
	export let protectedValue = null;

	let input,
		inputValue,
		activeOption,
		showOptions = false,
		selected = {},
		filtered = [],
		first = true,
		slot,
		protectedRegEx;

	const dispatch = createEventDispatcher();
	const iconClearPath =
		"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z";

	onMount(() => {
		initialise();
	});

	//$: {
	//    if (!first) {
	//        value = Object.values(selected).map(o => o.value);
	//    }
	//}
	$: {
		filtered = options.filter((o) => (inputValue ? o.name.toLowerCase().includes(inputValue.toLowerCase()) : o));
	}
	$: if ((activeOption && !filtered.includes(activeOption)) || (!activeOption && inputValue))
		activeOption = filtered[0];

	function initialise() {
		console.log("initialising Tag Selector");

		if (protectedValue) {
			protectedRegEx = new RegExp(protectedValue, "gi");
			options = options.filter((opt) => !opt.value.match(protectedRegEx));
		}
		console.log(options, "options");
		value.forEach((v) => {
			let contains = options.filter((opt) => opt.value == v).length;
			if (contains == 0) {
				options.push({ value: v, name: v });
			}
		});
		if (options.findIndex)
			options.forEach((o) => {
				var opt = document.createElement("option");
				opt.value = o.value;
				opt.innerHTML = o.name;
				slot.appendChild(opt);
			});

		if (value && value !== []) {
			console.log("Value", value);
			value.forEach((v) => {
				const option = options.filter((op) => op.name === v);
				console.log(option, "option");
				if (option.length) {
					selected = { ...selected, [option[0].value]: option[0] };
				} else if (protectedRegEx && v.match(protectedRegEx)) {
					selected = { ...selected, [v]: { name: v, value: v } };
				} else {
					addNew(v);
				}
			});
		}

		first = false;
		console.log(selected, "selected");
	}

	function add(token) {
		if (!readonly) {
			selected[token.value] = token;
			value = Object.values(selected).map((o) => o.value);

			inputValue = "";
			slot.dispatchEvent(new Event("change"));
			dispatch("add", selected[token.value]);
			dispatch("change");
		}
	}

	function addNew(newValue) {
		if (!readonly) {
			slot.dispatchEvent(new Event("change"));
			selected[newValue] = { name: newValue, value: newValue };
			value = Object.values(selected).map((o) => o.value);

			if (!protectedRegEx || !newValue.match(protectedRegEx)) {
				var opt = document.createElement("option");
				opt.value = newValue;
				opt.innerHTML = newValue;
				slot.appendChild(opt);

				options = [...options, { value: newValue, name: newValue }];
			}
			inputValue = "";

			dispatch("add", selected[newValue]);
			dispatch("change");
		}
	}

	function remove(value) {
		if (!readonly) {
			slot.dispatchEvent(new Event("change"));
			const { [value]: val, ...rest } = selected;
			selected = rest;
			value = Object.values(selected).map((o) => o.value);

			dispatch("remove", val);
			dispatch("change");
		}
	}

	function optionsVisibility(show) {
		if (readonly) return;
		if (typeof show === "boolean") {
			showOptions = show;
			show && input.focus();
		} else {
			showOptions = !showOptions;
		}
		if (!showOptions) {
			activeOption = undefined;
		}
	}

	function handleKeyup(e) {
		if (e.keyCode === 13) {
			if (activeOption) {
				Object.keys(selected).includes(activeOption.value) ? remove(activeOption.value) : add(activeOption);
			} else {
				addNew(inputValue);
			}
			inputValue = "";
		}
		if ([38, 40].includes(e.keyCode)) {
			// up and down arrows
			const increment = e.keyCode === 38 ? -1 : 1;
			const calcIndex = filtered.indexOf(activeOption) + increment;
			activeOption =
				calcIndex < 0
					? filtered[filtered.length - 1]
					: calcIndex === filtered.length
						? filtered[0]
						: filtered[calcIndex];
		}
	}

	function handleBlur(e) {
		optionsVisibility(false);
	}

	function handleTokenClick(e) {
		if (e.target.closest(".token-remove")) {
			e.stopPropagation();
			remove(e.target.closest(".token").dataset.id);
		} else if (e.target.closest(".remove-all")) {
			if (protectedRegEx) {
				let protectedSelections = Object.values(selected).filter((o) => o.value.match(protectedRegEx));
				console.log(protectedSelections);

				var mapped = protectedSelections.map((item) => ({
					[item.name]: { name: item.name, value: item.value }
				}));
				selected = Object.assign({}, ...mapped);

				console.log(protectedSelections);
				console.log(selected);
			} else {
				selected = {};
			}
			inputValue = "";
		} else {
			optionsVisibility(true);
		}
	}

	function handleOptionMousedown(e) {
		const value = e.target.dataset.value;
		console.log("Value", value);

		if (value) {
			if (selected[value]) {
				remove(value);
			} else {
				console.log(options);
				console.log(options.filter((o) => o.value == value));
				add(options.filter((o) => o.value == value)[0]);
				input.focus();
			}
		} else if (inputValue) {
			addNew(inputValue);
		}
	}
</script>

<div class="multiselect" class:readonly>
	<div class="tokens" class:showOptions on:click={handleTokenClick}>
		{#each Object.values(selected) as s}
			<div class="token" data-id={s.value}>
				<span>{s.name}</span>
				{#if !readonly && (!protectedRegEx || !s.value.match(protectedRegEx))}
					<div class="token-remove" title="Remove {s.name}">
						<svg
							class="icon-clear"
							xmlns="http://www.w3.org/2000/svg"
							width="18"
							height="18"
							viewBox="0 0 24 24">
							<path d={iconClearPath} />
						</svg>
					</div>
				{/if}
			</div>
		{/each}
		<div class="actions">
			{#if !readonly}
				<input
					{id}
					autocomplete="off"
					bind:value={inputValue}
					bind:this={input}
					on:keyup={handleKeyup}
					on:blur={handleBlur}
					{placeholder} />
				<!-- <div class="remove-all" title="Remove All" class:hidden={!Object.keys(selected).length}>
					<svg
						class="icon-clear"
						xmlns="http://www.w3.org/2000/svg"
						width="18"
						height="18"
						viewBox="0 0 24 24">
						<path d={iconClearPath} />
					</svg>
				</div> -->
				<svg
					class="dropdown-arrow"
					xmlns="http://www.w3.org/2000/svg"
					width="18"
					height="18"
					viewBox="0 0 18 18"><path d="M5 8l4 4 4-4z"></path></svg>
			{/if}
		</div>
	</div>

	<select bind:this={slot} type="multiple" class="hidden"></select>

	{#if showOptions && filtered.length}
		<ul
			class="options"
			transition:fly={{ duration: 200, y: 5 }}
			on:mousedown|preventDefault={handleOptionMousedown}>
			{#each filtered as option}
				<li
					class:selected={selected[option.value]}
					class:active={activeOption === option}
					data-value={option.value}>
					{option.name}
				</li>
			{/each}
		</ul>
	{:else if inputValue}
		<ul
			class="options"
			transition:fly={{ duration: 200, y: 5 }}
			on:mousedown|preventDefault={handleOptionMousedown}>
			<li>Press Enter or Click to add</li>
		</ul>
	{/if}
</div>

<style>
	.multiselect {
		background-color: white;
		/*    border-bottom: 1px solid hsl(0, 0%, 70%);*/
		position: relative;
	}
	/*  .multiselect:not(.readonly):hover {
  border-bottom-color: hsl(0, 0%, 50%);
}
*/
	.tokens {
		align-items: center;
		display: flex;
		flex-wrap: wrap;
		position: relative;
	}
	.tokens::after {
		background: none repeat scroll 0 0 transparent;
		bottom: -1px;
		content: "";
		display: block;
		height: 2px;
		left: 50%;
		position: absolute;
		background: hsl(45, 100%, 51%);
		transition:
			width 0.3s ease 0s,
			left 0.3s ease 0s;
		width: 0;
	}
	.tokens.showOptions::after {
		width: 100%;
		left: 0;
	}
	.token {
		align-items: center;
		background-color: hsl(214, 17%, 92%);
		border-radius: 1.25rem;
		display: flex;
		margin: 0.25rem 0.5rem 0.25rem 0;
		max-height: 1.3rem;
		padding: 0.25rem 0.5rem 0.25rem 0.5rem;
		padding: 1rem;
		transition: background-color 0.3s;
		white-space: nowrap;
	}
	.token:hover {
		background-color: hsl(214, 15%, 88%);
	}
	.readonly .token {
		color: hsl(0, 0%, 40%);
	}
	.token-remove,
	.remove-all {
		align-items: center;
		background-color: hsl(214, 15%, 55%);
		border-radius: 50%;
		color: hsl(214, 17%, 92%);
		display: flex;
		justify-content: center;
		height: 1.25rem;
		margin-left: 0.5rem;
		min-width: 1.25rem;
	}
	.token-remove:hover,
	.remove-all:hover {
		background-color: hsl(215, 21%, 43%);
		cursor: pointer;
	}

	.actions {
		align-items: center;
		display: flex;
		flex: 1;
		min-width: 15rem;
	}

	input {
		border: none;
		font-size: 1.2rem;
		line-height: 1.5rem;
		margin: 0;
		outline: none;
		padding: 10px;
		width: 100%;
	}

	.dropdown-arrow path {
		fill: hsl(0, 0%, 70%);
	}
	.multiselect:hover .dropdown-arrow path {
		fill: hsl(0, 0%, 50%);
	}

	.icon-clear path {
		fill: white;
	}

	.options {
		box-shadow:
			0px 2px 4px rgba(0, 0, 0, 0.1),
			0px -2px 4px rgba(0, 0, 0, 0.1);
		left: 0;
		list-style: none;
		margin-block-end: 0;
		margin-block-start: 0;
		max-height: 70vh;
		overflow: auto;
		padding-inline-start: 0;
		position: absolute;
		top: calc(100% + 1px);
		top: calc(100% - 20px);
		width: 100%;
		z-index: 200;
		margin-top: 1.2em;
		padding: 0;
	}
	li {
		background-color: white;
		cursor: pointer;
		padding: 0.5rem;
	}
	li:last-child {
		border-bottom-left-radius: 0.2rem;
		border-bottom-right-radius: 0.2rem;
	}
	li:not(.selected):hover {
		background-color: hsl(214, 17%, 92%);
	}
	li.selected {
		background-color: var(--color-primary);
		color: white;
	}
	li.selected:nth-child(even) {
		background-color: var(--color-primary-dark);
		color: white;
	}
	li.active {
		background-color: hsl(214, 17%, 88%);
	}
	li.selected.active,
	li.selected:hover {
		background-color: var(--color-border);
	}

	.hidden {
		display: none;
	}
</style>
